var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLayoutEffect, useRef } from 'react';
/**
 * Whether or not the user is manually managing the validation
 *
 * @param {boolean | undefined} valid The user controlled prop for valid
 * @param {string | undefined} errorMessage The user controlled prop for errorMessage
 * @param {boolean | undefined} showValidationState The user controlled prop for showValidationState
 * @param {(value: SetStateAction<V>) => void} setValidation Setter for managing validation internally
 * @returns {boolean} Whether or not the user is manually managing the validation
 */
export var useUserManagedValidation = function (valid, errorMessage, showValidationState, setValidation) {
    var userManagedValidation = useRef(valid !== undefined || errorMessage !== undefined || showValidationState !== undefined);
    useLayoutEffect(function () {
        userManagedValidation.current = valid !== undefined || errorMessage !== undefined || showValidationState !== undefined;
        // consumer is manually controlling validation props instead of with a citrus Form
        var validation = {};
        if (errorMessage !== undefined) {
            validation = { errorMessage: errorMessage };
        }
        if (valid !== undefined) {
            validation = __assign(__assign({}, validation), { valid: valid });
        }
        setValidation(validation);
    }, [errorMessage, showValidationState, valid]);
    return userManagedValidation.current;
};
